import { useLazyQuery, useQuery } from "@apollo/client";
import { TASK } from "../task.queries";
import { TaskQuery, TaskQueryVariables } from "../../../__generated__/TaskQuery";

export const useTask = (id: number) => {
  return useQuery<TaskQuery, TaskQueryVariables>(TASK, { variables: { id } });
};

export const useLazyTask = () => {
  return useLazyQuery<TaskQuery, TaskQueryVariables>(TASK);
};
